import Styles from './SimpleDropdown.module.scss'
import { ReactElement } from 'react'
import { ChevronRight } from 'almanac-ui/icons/12'

interface Props {
  icon?: ReactElement
  label?: string
  chevronLabel?: string
  withChevron?: boolean
}

export const SimpleDropdownItem = ({ icon, label, chevronLabel, withChevron }: Props) => {
  return (
    <div className={Styles.item}>
      {icon}
      <span className={Styles.label}>{label}</span>
      {(chevronLabel || withChevron) && (
        <div className={Styles.chevronLabel}>
          {chevronLabel}
          <ChevronRight />
        </div>
      )}
    </div>
  )
}
